import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Table } from 'rsuite'
import DragDropFileUpload from '../CommonComponents/DragDropFileUpload'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { ExcelRenderer } from 'react-excel-renderer'
import VendorExportModal from '../AssignVendorComponent/modals/export-modal'

import {
    validateFieldValue,
    formatValue,
} from '../../utils/validator/index'
import {
    isDiffTwoObj
} from '../../services/helper'
const { Column, HeaderCell, Cell, Pagination } = Table
export const EditCell = ({ rowData, dataKey, onChange, editingIds, ...props }) => {
    const idEditing = editingIds && editingIds.includes(rowData.id)
    return (
        <Cell {...props} className="table-link">
            {idEditing ? (
                <input
                    type="text"
                    className={`table-content-edit-span w-100`}
                    defaultValue={rowData[dataKey]}
                    onChange={(e) => onChange && onChange(rowData.id, dataKey, e.target.value)}
                />
            ) : (
                <div
                    className={`table-content-edit-span`}
                >
                    {rowData[dataKey]}
                </div>
            )
            }
        </Cell>
    )
}
let tableEditedData = []


const NotParsedAddressTable = ({ tableData, columns, onHandleContinue, onGoBack, onSelectFile }) => {
    const dispatch = useDispatch()
    const [tableRecords, setTableRecords] = useState([])
    const [editingIds, setEditingIds] = useState([])
    const [oldTableData, setOldTableData] = useState([])
    const [limit, setLimit] = React.useState(10)
    const [page, setPage] = React.useState(1)
    const [currentFileName, setCurrentFileName] = useState('')
    const [exportData, setExportData] = useState([])
    const [exportFileName, setExportFileName] = useState('')
    const [showExportModal, setShowExportModal] = useState(false)

    const handleFileChosen = (file) => {
        if (
            !file ||
            !(file.type === 'application/vnd.ms-excel' ||
                file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
                file.type === 'text/csv')
        ) {
            toast.show({
                title: 'Warning',
                description: 'File type should be .csv, .xls or xlsx!'
            })
            return
        }
        ExcelRenderer(file, (err, resp) => {
            if (err) {
                console.log(err)
            } else {
                loadUploadedFileContent(resp.rows, file.name)
            }
        })
    }

    const loadUploadedFileContent = (data, fileName) => {
        if (data.length === 0) {
            return
        }
        const cols = data.shift()
        const count = {}
        const duplicatedItems = []

        cols.forEach(col => {
            if (count[col]) {
                count[col] += 1
                return
            }
            count[col] = 1
        })

        for (let prop in count) {
            if (count[prop] >= 2) {
                duplicatedItems.push(prop)
            }
        }

        if (duplicatedItems.length > 0) {
            toast.show({
                title: 'Warning',
                description: `Column${duplicatedItems.length > 1 ? 's' : ''}: ${duplicatedItems.join(', ')} ${duplicatedItems.length > 1 ? 'are' : 'is'} duplicated! Please use unique column name.`
            })
            return
        }

        const tableData = []
        data.forEach(row => {
            const rowData = {}
            cols.forEach((col, index) => {
                rowData[col] = row[index]
            })
            tableData.push(rowData)
        })

        setCurrentFileName(fileName)
        onSelectFile(tableData)
    }

    const handleClickClear = () => {
        setCurrentFileName('')
    }

    useEffect(() => {
        setTableRecords(tableData)
        setOldTableData(tableData)
    }, [tableData])

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    }

    // when the table cell is changed(input and check)
    const handleChange = useCallback((id, key, value) => {
        if (tableEditedData?.findIndex(item => item.id === id) !== -1) {
            tableEditedData.find(item => item.id === id)[key] = value
            // set changed to true or false
            if (value !== oldTableData.find(row => row.id === id)[key]) {
                tableEditedData.find(item => item.id === id)['changed'] = true
            } else {
                tableEditedData.find(item => item.id === id)['changed'] = isDiffTwoObj({ ...tableEditedData.find(item => item.id === id), changed: false }, { ...oldTableData.find(row => row.id === id), changed: false })
            }
        } else {
            const newObj = tableData?.find(row => row.id === id)
            if (oldTableData?.find(row => row.id === id)[key] !== value) {
                newObj['changed'] = true
            }
            newObj[key] = value
            tableEditedData = [...tableEditedData, newObj]
        }
        tableEditedData.find(item => item.id === id)['edited'] = true
    }, [columns, tableData, oldTableData])

    const handleEditState = useCallback((id) => {
        let nextData = Object.assign([], tableRecords)
        // save for edited row
        if (editingIds && editingIds.includes(id)) {
            setEditingIds([...editingIds.filter(editingId => editingId !== id)])
            if (tableEditedData && tableEditedData.length > 0) {
                const editedRow = tableEditedData.find(row => row.id === id)
                const oldItem = nextData.find(row => row.id === id)
                const index = nextData.findIndex(row => row.id === id)
                if (index !== -1) {
                    nextData[index] = {
                        ...oldItem,
                        ...editedRow
                    }
                }
            }
            tableEditedData = [...tableEditedData.filter(row => row.id !== id)]
            setTableRecords(nextData)
        } else {
            // edit row
            setEditingIds([...editingIds, id])
            const oldItem = nextData.find(row => row.id === id)
            tableEditedData = [...tableEditedData, oldItem]
        }
    }, [tableRecords, editingIds])

    const ActionCell = ({ rowData, dataKey, ...props }) => {
        return (
            <Cell {...props} className="table-content-action justify-content-start" style={{ padding: '6px', display: 'flex', alignItems: 'center' }}>
                <button
                    type="button"
                    className="btn btn-green"
                    onClick={() => {
                        handleEditState(rowData.id);
                    }}
                >
                    {editingIds && editingIds.includes(rowData.id) ? 'Save' : 'Edit'}
                </button>
            </Cell>
        )
    }

    const headerElements = columns.map((col, index) => {
        if (index === 0) {
            return (
                <Column
                    resizable
                    sortable
                    key={col.name}
                >
                    <HeaderCell className='text-black fw-bold'>{col.label}</HeaderCell>
                    <Cell dataKey={col.name} />
                </Column>
            )
        }
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='text-black fw-bold'>{col.label}</HeaderCell>
                <EditCell dataKey={col.name} editingIds={editingIds} onChange={handleChange} />
            </Column>
        )
    })

    const handleShowExportModal = () => {
        let fileName = 'non-parsed-addresses';
        const exportData = [columns.map(column => column.label)]
        tableRecords.map(row => {
            if (!row.edited) {
                exportData.push(columns.map(column => row[column.name]))
            }
        })
        setExportData(exportData)
        setExportFileName(fileName)
        setShowExportModal(true)
    }
    const handleCloseExportModal = () => {
        setShowExportModal(false)
        setExportData([])
        setExportFileName('')
    }

    const filteredTableData = tableRecords.filter(row => {
        return row
    }).slice(limit * (page - 1), limit * page)

    return (
        <div className="match-tab">
            <div className="match-header">
            </div>
            <div className="match-tab-action">
                <button type="button" className="btn btn-white back"
                    onClick={onGoBack}
                >
                    Go Back
                </button>
                <button type="button" className="btn btn-black continue" onClick={handleShowExportModal}>
                    Export
                </button>
            </div>
            <div className={`card match-content shadow-none border-0 mt-5`}>
                <div className="card-content p-0 border border-2 rounded">
                    <Table
                        key={`preview-table-key-${columns?.length}`}
                        virtualized
                        affixHeader={true}
                        data={filteredTableData}
                        autoHeight
                        affixHorizontalScrollbar={true}
                        className='border-0'
                    >
                        {headerElements}
                        <Column
                            width={100}
                            fixed='right'
                        >
                            <HeaderCell className='text-black fw-bold'>Action</HeaderCell>
                            <ActionCell
                                dataKey='id'
                            />
                        </Column>
                    </Table>
                    <div className="pagination">
                        <Pagination
                            prev
                            next
                            first
                            last
                            showInfo
                            maxButtons={5}
                            lengthMenu={[
                                {
                                    label: '5',
                                    value: 5,
                                },
                                {
                                    label: '10',
                                    value: 10,
                                },
                            ]}
                            displayLength={limit}
                            total={tableRecords.length}
                            limit={limit}
                            activePage={page}
                            onChangePage={setPage}
                            onChangeLength={handleChangeLimit}
                        />
                    </div>
                </div>
            </div>
            <div className="mt-5">
                <h4 className='mb-4 text-black fw-bold'> Import Manually Parsed Address Information </h4>
                <div className="upload-tab gap-5 d-flex align-items-center flex-column flex-md-row shadow-none border border-2">
                    <div className="upload-action d-flex flex-column">
                        <DragDropFileUpload
                            currentFileName={currentFileName}
                            onFileChosen={handleFileChosen}
                            customClassName='upload-vendor-file'
                        />
                        {
                            currentFileName ? <button type="button" className="btn btn-red clear text-white" onClick={handleClickClear}>Remove</button>
                                : <span className='h4'>.csv, .xls and .xlsx files accepted</span>
                        }
                    </div>
                    <div className="upload-note h4">
                        You can upload any .csv, .xls, .xlsx file with any set of columns as long as it has 1 record per row. The next step will allow you to match your spreadsheet to the right datapoint. You'll be able to clean up or remove any corrupted data before finalizing your report.
                    </div>
                </div>
            </div>
            <div className="match-tab-action mt-3 float-end">
                <button type="button" className="btn btn-black continue"
                    onClick={() => { onHandleContinue(currentFileName) }}
                >
                    Continue
                </button>
            </div>
            <VendorExportModal
                show={showExportModal}
                exportData={exportData}
                onClose={handleCloseExportModal}
                fileName={exportFileName}
            />
        </div>
    )
}

export default NotParsedAddressTable